import React, { Component } from 'react';
import { Box, Flex, Text } from 'core/components';
import styled from 'styled-components';
import Markdown from '../../journeys/Markdown';
import ToolResultCard from '../components/ToolResultCard';
import { getToolDisplayName } from '../ToolResultFactory';

const ToolMarkdownWrap = styled(Box)`
  h3,
  h4 {
    margin-top: 0;
  }
`;

function parseRawResult(raw_result) {
  if (!raw_result) {
    return {};
  }
  if (typeof raw_result === 'string') {
    try {
      return JSON.parse(raw_result);
    } catch (e) {
      return {};
    }
  }
  return raw_result;
}

function getStatusColor(status) {
  if (status === 'COMPLETED') {
    return 'success';
  }
  if (status === 'FAILED') {
    return 'danger';
  }
  return 'warning';
}

class SubAgentToolResult extends Component {
  render() {
    const { tool, onCloseToolResult, isInlineMode = false } = this.props;
    const { processed_result } = tool;
    const rawData = parseRawResult(tool.raw_result);
    const { subAgentName, status, stepsExecuted, toolCallsMade, finalAnswer } = rawData;

    const displayAnswer = finalAnswer || processed_result;
    const tools = Array.isArray(toolCallsMade) ? toolCallsMade : [];
    const hasMeta = Boolean(status) || typeof stepsExecuted === 'number' || tools.length > 0;

    const answerBody = displayAnswer ? (
      <ToolMarkdownWrap>
        <Markdown>{displayAnswer}</Markdown>
      </ToolMarkdownWrap>
    ) : (
      <Text muted>No answer was produced by the sub-agent.</Text>
    );

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        className="tool-result-sub-agent"
        title={tool.title || `${subAgentName || 'Sub-Agent'} Result`}
        isInlineMode={isInlineMode}
        minHeight={isInlineMode ? 0 : 600}
        maxHeight={isInlineMode ? 500 : undefined}
        overflow={isInlineMode ? 'auto' : 'hidden'}
      >
        <Flex
          flexDirection="column"
          p={2}
          gap={2}
          flex={isInlineMode ? undefined : 1}
          overflow={isInlineMode ? undefined : 'hidden'}
        >
          {hasMeta && (
            <Flex flexWrap="wrap" style={{ gap: '8px' }}>
              {status && (
                <Text small fontWeight="bold" color={getStatusColor(status)}>
                  {status}
                </Text>
              )}
              {typeof stepsExecuted === 'number' && (
                <Text small muted>
                  {stepsExecuted} {stepsExecuted === 1 ? 'step' : 'steps'}
                </Text>
              )}
              {tools.length > 0 && (
                <Text small muted>
                  Tools: {tools.map((tc) => getToolDisplayName(tc.name)).join(', ')}
                </Text>
              )}
            </Flex>
          )}

          {/* Render the sub-agent / MCP answer inline in both panel and inline modes so
              markdown tables and links "drop below" the call inside the transcript overlay. */}
          {isInlineMode ? (
            answerBody
          ) : (
            <Box flex={1} overflow="auto">
              {answerBody}
            </Box>
          )}
        </Flex>
      </ToolResultCard>
    );
  }
}

export default SubAgentToolResult;
